"use strict";
exports.__esModule = true;
exports.LegendAxisIndicator = exports.LegendAxisIndicatorClass = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var locales_1 = require("../locales");
var LegendAxisIndicatorClass = /** @class */ (function (_super) {
    tslib_1.__extends(LegendAxisIndicatorClass, _super);
    function LegendAxisIndicatorClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegendAxisIndicatorClass.prototype.render = function () {
        var _a = this.props, labelKey = _a.labelKey, width = _a.width, data = _a.data, intl = _a.intl;
        var style = width ? { width: width + "px" } : {};
        var values = (data || []).reduce(function (result, key, index) {
            result[index] = intl.formatMessage(locales_1.messages[key]);
            return result;
        }, {});
        return (react_1["default"].createElement("div", { style: style, className: "series-axis-indicator" },
            react_1["default"].createElement("div", { className: "series-text" },
                intl.formatMessage(locales_1.messages[labelKey], values),
                intl.formatMessage(locales_1.messages["colon"]))));
    };
    return LegendAxisIndicatorClass;
}(react_1["default"].PureComponent));
exports.LegendAxisIndicatorClass = LegendAxisIndicatorClass;
exports.LegendAxisIndicator = react_intl_1.injectIntl(LegendAxisIndicatorClass);
//# sourceMappingURL=LegendAxisIndicator.js.map